import { TextInput } from "@avenueops/web-components";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

interface Props {
  search?: string;
  setSearch: (_: string) => void;
  placeholder?: string;
  size?: "SMALL" | "MEDIUM" | "LARGE";
}

/**
 * A search bar used to filter tables.
 * Pass in the appropriate context through the parameters search and setSearch.
 */
export default function SearchBar({ search, setSearch, placeholder, size = "LARGE" }: Props): JSX.Element {
  const [internalValue, setInternalValue] = useState<string>(search ?? "");
  return (
    <TextInput
      name="searchBar"
      size={size}
      Icon={MagnifyingGlassIcon}
      placeholder={placeholder ?? "Search"}
      defaultValue={internalValue ?? ""}
      onChange={(e) => {
        setInternalValue(e.target.value);
        setSearch(e.target.value);
      }}
    />
  );
}
